import React from 'react'
import "./style/gallery.css"
import {buildRawImageObj} from '../lib/helpers'
import {imageUrlFor} from '../lib/image-url'
import { SRLWrapper } from "simple-react-lightbox";

function Gallery (props) {
const {images} = props

const options = {
  thumbnails: {
    showThumbnails: false
  },
  buttons: {
    showDownloadButton: false,
    showNextButton: false,
    showPrevButton: false
  }
};

if(images.length > 1) {
  options.buttons.showNextButton = true
  options.buttons.showPrevButton = true
}

return (

  <>

  <SRLWrapper options={options}>

      {images && images.map(image => {

        return image.asset && (

        <div className="gallery-image">
        <a data-attribute="SRL" href={imageUrlFor(buildRawImageObj(image))
              .width(2000)
              .url()}
        >
          <img
            src={imageUrlFor(buildRawImageObj(image))
              .width(1200)
              .url()}
            alt={images[0].alt}
          />
          </a>
        </div>
      )
      })}
  </SRLWrapper>

    </>

)}

export default Gallery